import { Http } from '@/lib/http';

export class TransactionMonitoringCycleService extends Http {
  constructor() {
    super();
    this.endpoint = '/aml-pro/settings/transaction-monitoring-cycles/';
  }

  fetchAll()       { return this.httpClient().get(this.endpoint); }
  fetchOne(id)     { return this.httpClient().get(`${this.endpoint}${id}`); }
  create(data)     { return this.httpClient().post(this.endpoint, data); }
  update(id, data) { return this.httpClient().patch(`${this.endpoint}${id}`, data); }
  delete(id)       { return this.httpClient().delete(`${this.endpoint}${id}`); }

  addStage(cycleId, data)                        { return this.httpClient().post(`${this.endpoint}${cycleId}/stages`, data); }
  updateStage(cycleId, stageId, data)            { return this.httpClient().patch(`${this.endpoint}${cycleId}/stages/${stageId}`, data); }
  deleteStage(cycleId, stageId)                  { return this.httpClient().delete(`${this.endpoint}${cycleId}/stages/${stageId}`); }

  addAction(cycleId, stageId, data)              { return this.httpClient().post(`${this.endpoint}${cycleId}/stages/${stageId}/actions`, data); }
  reorderActions(cycleId, stageId, data)         { return this.httpClient().patch(`${this.endpoint}${cycleId}/stages/${stageId}/actions/reorder`, data); }
  updateAction(cycleId, stageId, actionId, data) { return this.httpClient().patch(`${this.endpoint}${cycleId}/stages/${stageId}/actions/${actionId}`, data); }
  deleteAction(cycleId, stageId, actionId)       { return this.httpClient().delete(`${this.endpoint}${cycleId}/stages/${stageId}/actions/${actionId}`); }
}